module.exports = __webpack_public_path__ + "static/media/dyplom.7ef5112d.png";